
  import React from "react"
  import Component from "/Users/davidbaker/code/davidbaker.is/src/layouts/index.js"
  import data from "/Users/davidbaker/code/davidbaker.is/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js